import React, { useEffect, useState } from 'react';
import {
  Button,
  Layout,
  Space,
  Typography,
  Menu,
  Dropdown,
  Avatar,
} from 'antd';
import get from 'lodash/get';
import { useHistory, withRouter } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { UserOutlined, DownOutlined } from '@ant-design/icons';
// import BrandSelector from '../brandSelector';
import { LOGOUT, SIGNUP, LOGIN } from '../../constants/routes';
import { userMangement } from '../../redux/actions/authActions';
import Logo from '../../assets/common/logo.png';

const { Header } = Layout;
const { Title } = Typography;

function LayoutHeader({ setLoading }) {
  const auth = useSelector((state) => get(state, 'auth', false));
  const [currentPage, setCurrentPage] = useState({
    loginPage: true,
  });
  const { isLoggedIn, user } = auth;
  const history = useHistory();
  const dispatch = useDispatch();

  const onClickLogout = () => {
    setLoading(true);
    dispatch(userMangement('logout'))
      .then(() => {
        setLoading(false);
        history.replace(LOGOUT);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const onChangeRoute = () => {
    if (!isLoggedIn) {
      if (
        history.location.pathname === '/' ||
        history.location.pathname === '/login'
      ) {
        setCurrentPage({ loginPage: true });
      } else {
        setCurrentPage({ loginPage: false });
      }
    }
  };

  useEffect(() => {
    onChangeRoute();
    const unlisten = history.listen(onChangeRoute);
    return unlisten;
  }, []);

  const menu = (
    <Menu>
      <Menu.Item
        key="2"
        onClick={() => {
          onClickLogout();
        }}
      >
        Logout
      </Menu.Item>
    </Menu>
  );

  return (
    <Header className="main-header">
      {!isLoggedIn ? (
        <>
          <div className="header-left-container">
            <img src={Logo} alt="" />
          </div>
          <div className="header-right-container">
            <Space size="large">
              <Button
                className="login-btn"
                type="primary"
                onClick={() => {
                  history.push(get(currentPage, 'loginPage') ? SIGNUP : LOGIN);
                }}
              >
                {get(currentPage, 'loginPage') ? 'Sign Up' : 'Login'}
              </Button>
            </Space>
          </div>
        </>
      ) : (
        <>
          <div className="header-left-container">
            {/* <BrandSelector setLoading={setLoading} /> */}
          </div>
          <div className="header-right-container">
            <Dropdown overlay={menu} placement="bottomCenter">
              <Space size="large">
                <Avatar size={40} icon={<UserOutlined />} />
                <Title level={5}>{get(user, 'name')}</Title>
                <DownOutlined />
              </Space>
            </Dropdown>
          </div>
        </>
      )}
    </Header>
  );
}

export default withRouter(LayoutHeader);
